// extracted by mini-css-extract-plugin
export default {"wrapper":"fee-card_wrapper__NxBqE","edit":"fee-card_edit__3FQ2T","delete":"fee-card_delete__e3WZN","action":"fee-card_action__72lL-"};